import { getJobboxJson, getJsonKeywords, getJobboxSiteString } from "./functions/jobbox";

const global = window as any;
const isJobbox = global.isJobbox;

global.isJobbox.getJsonKeywords = getJsonKeywords;
global.isJobbox.getJobboxJson = getJobboxJson;
global.isJobbox.getJobboxSiteString = getJobboxSiteString;

!(async function () {
  isJobbox?.cmd?.forEach((func: () => void) => {
    func();
  });
})();